import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = () => {
  return (
    <div className="flex h-screen bg-gradient-to-r from-slate-100 via-indigo-100 to-purple-100 animate-fadeInSlow">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-6 transition-all duration-500 ease-in-out">
          <div className="bg-white rounded-2xl shadow-xl p-6 min-h-full animate-slideUp">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
